<template>
  <section class="labor-hero">
    <div class="nav-title">
      <div class="section nav-inner">
        <div class="logo">
          <img class="navbarLogo" src="@/static/image/navbarLogo.png" :alt="localized.logoAlt" />
        </div>
        <div class="navbar" id="navbar">
          <a v-for="item in localized.topNavs" :key="item.key" :href="item.href" class="nav-item">{{ item.label }}</a>
          <button type="button" class="nav-item lang" @click="$emit('toggle-language')">
            {{ localized.switchLabel }}
          </button>
        </div>
      </div>
    </div>

    <div class="banner">
      <div class="b_title">
        <div class="h1">{{ localized.banner.title }}</div>
        <div class="h2">{{ localized.banner.subtitle }}</div>
      </div>
    </div>

    <div class="bread_bar_wrapper">
      <div class="bread_bar section">
        <div class="left">
          <img class="item icon home-icon" src="@/static/image/about6.png" alt="home" />
          <a v-for="item in localized.breadcrumbs" :key="item.key" class="item" :class="{ active: item.key === 'home' }" :href="item.href || 'javascript:void(0)'">{{ item.label }}</a>
        </div>
        <div class="right">
          <button v-for="item in localized.tabs" :key="item.key" type="button" class="item fw" :class="{ active: activeTab === item.key }" @click="$emit('change-tab', item.key)">
            {{ item.label }}<span class="border"></span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LaborHero',
  props: {
    activeTab: { type: String, required: true },
    topNavs: { type: Array, required: true },
    breadcrumbs: { type: Array, required: true },
    tabs: { type: Array, required: true }
  },
  computed: {
    localized() {
      console.log('[LaborHero localized]', {
        locale: this.$i18n && this.$i18n.locale,
        switchLabel: this.$t('lang.switchToEn'),
        title: this.$t('laborRelations.banner.title')
      })
      const isZh = (this.$i18n && this.$i18n.locale) !== 'en'
      return {
        logoAlt: this.$t('laborRelations.nav.logoAlt'),
        switchLabel: isZh ? this.$t('lang.switchToEn') : this.$t('lang.switchToZh'),
        banner: {
          title: this.$t('laborRelations.banner.title'),
          subtitle: this.$t('laborRelations.banner.subtitle')
        },
        topNavs: this.topNavs.map(item => ({ ...item, label: this.$t(item.labelKey) })),
        breadcrumbs: this.breadcrumbs.map(item => ({ ...item, label: this.$t(item.labelKey) })),
        tabs: this.tabs.map(item => ({ ...item, label: this.$t(item.labelKey) }))
      }
    }
  }
}
</script>

<style scoped>
.labor-hero { background: #fff; }
.section { width: 1200px; margin: 0 auto; }
.nav-title { height: 86px; border-top: 4px solid #4b2a1d; background: #fff; box-shadow: 0 1px 8px rgba(0,0,0,.08); }
.nav-inner { height: 100%; display: flex; align-items: center; justify-content: space-between; }
.logo img { display: block; height: 42px; }
.navbar { display: flex; align-items: center; gap: 34px; white-space: nowrap; }
.nav-item { color: #333; text-decoration: none; font-size: 16px; }
.nav-item.lang { color: #1c51a3; background: transparent; border: 0; padding: 0; cursor: pointer; }
.banner { height: 280px; background: url('~@/static/image/pro-manage1.png') no-repeat center/cover; position: relative; }
.b_title { text-align: center; padding-top: 86px; color: #fff; }
.b_title .h1 { font-size: 44px; font-weight: 700; }
.b_title .h2 { font-size: 26px; margin-top: 8px; }
.bread_bar_wrapper { height: 62px; border-bottom: 1px solid #eee; }
.bread_bar { height: 100%; display: flex; justify-content: space-between; align-items: center; }
.left .item { margin-right: 8px; color: #333; text-decoration: none; }
.left .icon { width: 17px; vertical-align: middle; }
.home-icon { transform: translateY(-19px); }
.right { display: flex; align-items: center; gap: 34px; }
.right .item { color: #333; text-decoration: none; position: relative; padding: 18px 0 16px; background: transparent; border: 0; font: inherit; cursor: pointer; }
.right .item.active { color: #1c51a3; }
.right .item .border { display: block; height: 2px; width: 100%; background: #1c51a3; margin-top: 6px; opacity: 0; }
.right .item.active .border { opacity: 1; }
</style>

